import React, { useState, useEffect } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import Alert from "../common/Alert";
import SessionHelper from "../../helpers/SessionHelper";
import PopUp from "../wdpMap/AlertPopup";
import CropService from "../../api-service/CropService";
import { useSelector, useDispatch } from "react-redux";
import { setUserCropDetails } from "../../configurations/redux-configurations/actions/fieldAction";
import _ from "lodash";
import {
  SURE_TO_REMOVE,
  PLEASE_ENTER_VALID_DATA,
  ADD_ATLEAST_ONE_CROP,
  CROP_UNIQUE_FOR_SEASON,
  CROP_ACRES_GREATER_THAN_ZERO,
  CROP_ACRES_NOT_EXCEED_FIELD_ACRES,
  DATA_SAVED_SUCCESSFULLY,
  ERROR_WHILE_SAVING_DATA,
  ERROR_SAVING_CROP_DETAILS,
  CROP_ALREADY_EXIST,
  RELOAD_PAGE_TRY_AGAIN,
} from "../../configurations/MessageConstants";
import CropDetailsList from "./CropDetailsList";
import LoadingOverlay from "../common/LoadingOverlay";
import {
  ACRES_EXECEEDED,
  DANGER,
  DUPLICATE_CROP,
  EMPTY,
  INFO,
  START_YEAR,
} from "../../configurations/Constants";
import { StatusCodes } from "../../configurations/status-codes";

function TabCropDetails(props) {
  const dispatch = useDispatch();

  const UserCropDetails = useSelector((state) => state.field.userCropDetails);

  const [crops, setCrops] = useState([]);
  const [availableAcres, setAvailableAcres] = useState(0);
  const [variant, setVariant] = useState(EMPTY);
  const [alertMessage, setAlertMessage] = useState(EMPTY);
  const [submitError, setSubmitError] = useState(false);
  const [validated, setValidated] = useState(false);
  const [year, setYear] = useState(EMPTY);
  const [originalCrops, setOriginalCrops] = useState([]);
  const [removeCrop, setRemoveCrop] = useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [confirmPopupMessage, setConfirmPopupMessage] = useState(EMPTY);
  const [index, setIndex] = useState(EMPTY);
  const [header, setHeader] = useState(EMPTY);
  const [savedDeleted, setSavedDeleted] = useState(0);
  const [validatedYears, setValidatedYears] = useState([]);
  const [yearAcresDetails, setYearAcresDetails] = useState({});
  const [yearAcre, setYearAcre] = useState(0);
  const [overlayLoading, setOverlayLoading] = useState(false);
  const [acreWarning, setAcreWarning] = useState(true);

  useEffect(() => {
    let currentYear = new Date().getFullYear();
    let validatedYearsValue = [];
    if (props.SharedField) {
      validatedYearsValue = getValidatedSeasons(props.sharedFieldDetails);
      currentYear =
        validatedYearsValue.length > 0 &&
        validatedYearsValue.some((access) => access.year === currentYear)
          ? currentYear
          : validatedYearsValue[validatedYearsValue.length - 1].year;
    }
    setCrops(props.crops);
    setOriginalCrops(props.crops);
    setYearAcresDetails(props.yearAcresDetails);
    setYear(currentYear);
    setYearAcre(props.acres);
    setValidatedYears(validatedYearsValue);
    getYearAcresForIrrigUnitId(props.crops, currentYear);
  }, []);

  const closeAlert = () => {
    setAlertMessage(EMPTY);
    setVariant(DANGER);
    setSubmitError(false);
  };

  const getValidatedSeasons = (sharedFieldDetails) => {
    let seasonAllowed = [];
    if (sharedFieldDetails.length > 0) {
      let currentyear = new Date().getFullYear();

      for (let i = 0; i < sharedFieldDetails.length; i++) {
        let rowData = sharedFieldDetails[i];
        let addedDate = new Date(rowData.added_on);
        let addedYear = addedDate.getFullYear();
        let removedOn = rowData.removed;
        let permission = false;
        let seasonChangeDate = new Date(`15/APR/${addedYear}`).getTime();
        let year = 0;
        let removedYear =
          removedOn !== null ? new Date(rowData.removed).getFullYear() : null;
        if (addedYear === removedYear && removedYear !== null) {
          year = addedYear;
          permission = false;
          seasonAllowed.push({ year: year, permission: permission });
        } else if (addedYear !== removedYear && removedYear !== null) {
          for (let j = addedYear; j < removedYear; j++) {
            year = j;
            permission = false;
            seasonAllowed.push({ year: year, permission: permission });
            year += 1;
            if (year === removedYear) {
              seasonChangeDate = new Date(`15/APR/${year}`).getTime();
              if (removedOn > seasonChangeDate) {
                permission = false;
                seasonAllowed.push({ year: year, permission: permission });
              }
            }
          }
        } else if (removedYear === null) {
          for (let j = addedYear; j <= currentyear; j++) {
            year = j;
            permission = sharedFieldDetails[i].editor === true ? true : false;
            seasonAllowed.push({ year: year, permission: permission });
          }
        }
      }
    }
    return seasonAllowed;
  };

  const handleChangeYear = (e) => {
    let yearValue = e.target.value;
    setYear(yearValue);
    setCrops(originalCrops);
    getYearAcresForIrrigUnitId(originalCrops, yearValue);
  };

  const getYearAcresForIrrigUnitId = (cropValue, year) => {
    let irrig_unit_id = props.irrig_unit_Id;
    let acresYearData = yearAcresDetails;
    let yearDetails = acresYearData[irrig_unit_id];
    if (yearDetails) {
      let yearData = yearDetails.tp_year_wise_data.filter(
        (yearRow) => yearRow.crop_year.toString() === year.toString()
      );
      if (yearData.length > 0) {
        setYearAcre(yearData[0].acres);
      } else {
        setYearAcre(props.acres);
      }
    }
    calculateRemainingAcres(cropValue, year, props.acres);
  };

  const calculateRemainingAcres = (cropValue, yearValue, yearAcresValue) => {
    let addedAcres = 0;
    let availableAcresValue = 0;
    let filteredCrops = cropValue.filter(
      (c) => c.year.toString() === yearValue.toString()
    );
    for (let i = 0; i < filteredCrops.length; i++) {
      if (
        filteredCrops[i].deleted === false &&
        parseFloat(filteredCrops[i].acres)
      ) {
        addedAcres += parseFloat(filteredCrops[i].acres);
      }
    }
    availableAcresValue = parseFloat(yearAcresValue) - addedAcres.toFixed(2);
    setAvailableAcres(availableAcresValue.toFixed(2));
  };

  const handleRemoveCropEntries = (idx, cropNameValue) => () => {
    setShowConfirmPopup(true);
    setRemoveCrop(true);
    setHeader("Remove Crop");
    setConfirmPopupMessage(SURE_TO_REMOVE + cropNameValue + " crop?");
    setIndex(idx);
    setSavedDeleted(1);
  };

  const handleAddCrop = () => {
    setCrops(
      crops.concat([
        {
          acres: EMPTY,
          year: year.toString(),
          tillage: "CTill",
          crop: "Corn",
          deleted: false,
        },
      ])
    );
    const cropDiv = document.getElementsByClassName("crop-row-height");
    cropDiv[0].scrollTop = cropDiv[0].scrollHeight;
  };

  const handleCropNameChange = (idx) => (evt) => {
    evt.persist();
    let newCrop = crops.map((crop, sidx) => {
      if (idx !== sidx) return crop;
      return { ...crop, [evt.target.name]: evt.target.value };
    });
    setCrops(newCrop);

    if (evt.target.name === "acres") {
      calculateRemainingAcres(newCrop, year, yearAcre);
    }
  };

  const handleSavedRemoveCropEntries = (idx, cropNameValue) => () => {
    setShowConfirmPopup(true);
    setRemoveCrop(true);
    setHeader("Remove Crop");
    setConfirmPopupMessage(SURE_TO_REMOVE + cropNameValue + " crop?");
    setIndex(idx);
    setSavedDeleted(2);
  };

  const performWarningAction = (e, idx) => {
    if (savedDeleted === 1) {
      let cropValue = crops.filter((s, sidx) => idx !== sidx);
      setCrops(cropValue);
      calculateRemainingAcres(cropValue, year, yearAcre);

      setShowConfirmPopup(false);
      setRemoveCrop(false);
      setHeader(EMPTY);
      setConfirmPopupMessage(EMPTY);
      setIndex(EMPTY);
      setSavedDeleted(0);
    } else if (savedDeleted === 2) {
      let newCrop = crops.map((crop, sidx) => {
        if (idx !== sidx) return crop;
        return { ...crop, deleted: true };
      });
      setCrops(newCrop);
      calculateRemainingAcres(newCrop, year, yearAcre);

      setShowConfirmPopup(false);
      setRemoveCrop(false);
      setHeader(EMPTY);
      setConfirmPopupMessage(EMPTY);
      setIndex(EMPTY);
      setSavedDeleted(0);
    }
  };

  const closeWarningPopup = () => {
    setShowConfirmPopup(false);
    setConfirmPopupMessage(EMPTY);
    setRemoveCrop(false);
    setIndex(EMPTY);
    setHeader(EMPTY);
  };

  const saveCropDetails = async (e, closePopUp) => {
    e.preventDefault();
    e.stopPropagation();
    await SessionHelper.handleRefreshToken();

    let currentCrops = [];

    const form = document.getElementById("formFieldDetails");
    if (form.checkValidity() === false) {
      handleShowErrorAlert(
        PLEASE_ENTER_VALID_DATA,
        {
          validated: true,
        },
        DANGER
      );
      return false;
    } else {
      currentCrops = crops.filter(
        (crop) => crop.year.toString() === year.toString()
      );

      if (currentCrops.length === 0) {
        handleShowErrorAlert(
          ADD_ATLEAST_ONE_CROP,
          {
            validated: true,
          },
          DANGER
        );

        return false;
      }
      const cropArr = currentCrops.map((crop) => {
        return crop.crop;
      });
      const isDuplicate = cropArr.some(
        (item, idx) => cropArr.indexOf(item) !== idx
      );
      if (isDuplicate === true) {
        handleShowErrorAlert(
          CROP_UNIQUE_FOR_SEASON,
          {
            validated: true,
          },
          DANGER
        );
        return false;
      }
      const cropAcres = currentCrops.filter(
        (crop) => parseFloat(crop.acres) <= 0
      );

      if (cropAcres.length > 0) {
        handleShowErrorAlert(
          CROP_ACRES_GREATER_THAN_ZERO,
          {
            validated: true,
          },
          DANGER
        );

        return false;
      }

      if (parseFloat(availableAcres) < 0) {
        handleShowErrorAlert(
          CROP_ACRES_NOT_EXCEED_FIELD_ACRES,
          {
            validated: true,
          },
          DANGER
        );

        return false;
      }
      if (parseFloat(availableAcres) !== 0 && acreWarning === true) {
        handleShowErrorAlert(
          `Are you sure you want to save with ${availableAcres} acres still available?`,
          {
            validated: true,
          },
          "warning"
        );
        setAcreWarning(!acreWarning);
        return false;
      }
      setAcreWarning(!acreWarning);
    }
    setOverlayLoading(true);
    setValidated(false);

    let updatedCrops = [];
    for (let i = 0; i < currentCrops.length; i++) {
      let requiredObject = (({ id, acres, crop, tillage, deleted }) => ({
        id,
        acres,
        crop,
        tillage,
        deleted,
      }))(currentCrops[i]);
      updatedCrops.push(requiredObject);
    }
    let payload = {
      field_id: props.fieldId,
      irrig_unit_id: props.irrig_unit_Id,
      farm_practices: updatedCrops,
      year: year,
    };
    await saveCropDetailsForField(payload, closePopUp);
  };

  const updateCropDetailsList = (payloadSubmitted) => {
    let userFieldCrops = UserCropDetails;
    let fieldIdToDelete = EMPTY;
    if (payloadSubmitted.length !== 0) {
      fieldIdToDelete = payloadSubmitted[0].user_field_id;
    } else {
      fieldIdToDelete = props.fieldId;
    }
    _.remove(userFieldCrops, {
      user_field_id: fieldIdToDelete,
    });
    let result = _.unionBy(payloadSubmitted, userFieldCrops, "id");
    dispatch(setUserCropDetails(result));
  };

  const saveCropDetailsForField = async (payload, closeModal) => {
    try {
      const response = await CropService.updateCropDetails(payload);
      let responseData = response.data;
      updateCropDetailsList(responseData.data);
      if (closeModal === true) {
        props.closeModal();
      } else {
        setCrops(responseData.data);
        setOriginalCrops(responseData.data);
      }
      setOverlayLoading(false);
      setSubmitError(true);
      setAlertMessage(DATA_SAVED_SUCCESSFULLY);
      setVariant(INFO);

      handleShowErrorAlert(
        DATA_SAVED_SUCCESSFULLY,
        { overlayLoading: false },
        INFO
      );
    } catch (error) {
      let responseData = error.response.data;
      if (error.response.status === StatusCodes.BAD_REQUEST) {
        let errorMessage = ERROR_WHILE_SAVING_DATA;
        if (responseData.data === DUPLICATE_CROP) {
          errorMessage = CROP_ALREADY_EXIST + ", " + RELOAD_PAGE_TRY_AGAIN;
        } else if (responseData.data === ACRES_EXECEEDED) {
          errorMessage =
            CROP_ACRES_NOT_EXCEED_FIELD_ACRES + ", " + RELOAD_PAGE_TRY_AGAIN;
        }
        handleShowErrorAlert(
          errorMessage,
          {
            overlayLoading: false,
          },
          DANGER
        );
        await props.refreshPanel(false);
      } else {
        handleShowErrorAlert(
          ERROR_SAVING_CROP_DETAILS,
          {
            overlayLoading: false,
          },
          DANGER
        );
      }
    }
  };

  const handleShowErrorAlert = (errorMessage, newProps, variant) => {
    setSubmitError(true);
    setAlertMessage(errorMessage);
    setVariant(variant);
    for (let Propskey in newProps) {
      if (Propskey === "validated") setValidated(newProps[Propskey]);
      if (Propskey === "overlayLoading") setOverlayLoading(newProps[Propskey]);
    }
  };

  const handleLoadYears = () => {
    let yearsValue = [];
    let currentYearValue = new Date().getFullYear();
    for (let i = currentYearValue; i >= START_YEAR; i--) {
      if (props.SharedField) {
        if (
          validatedYears.some((obj) => obj.year.toString() === i.toString())
        ) {
          yearsValue.push(
            <option key={`year_${i}`} value={i}>
              {i}
            </option>
          );
        }
      } else {
        yearsValue.push(
          <option key={`year_${i}`} value={i}>
            {i}
          </option>
        );
      }
    }
    return yearsValue;
  };

  const cropDetails = [];
  let hasAccessValue = false;

  if (!props.SharedField) {
    hasAccessValue = true;
  } else {
    let object = validatedYears.filter((yearValue) => {
      return yearValue.year.toString() === year.toString();
    });
    if (object.length > 0) {
      hasAccessValue = object[0].permission;
    }
  }

  const years = handleLoadYears();
  let indexValue = 0;
  for (let j = 0; j < crops.length; j++) {
    if (
      crops[j].year.toString() !== year.toString() ||
      crops[j].deleted === true
    ) {
      continue;
    }

    indexValue += 1;
    cropDetails.push(
      <CropDetailsList
        crop={crops[j]}
        key={j}
        cropIndex={j}
        indexValue={indexValue}
        hasAccessValue={hasAccessValue}
        handleCropNameChange={handleCropNameChange}
        handleRemoveCropEntries={handleRemoveCropEntries}
        handleSavedRemoveCropEntries={handleSavedRemoveCropEntries}
      />
    );
  }

  if (cropDetails.length === 0) {
    cropDetails.push(
      <span key="noCropAdded" style={{ fontStyle: "italic" }}>
        No crop added
      </span>
    );
  }
  return (
    <div>
      <LoadingOverlay
        showSpinner={true}
        active={overlayLoading}
        text="Updating Crop Details..."
      />
      <div id="forPrimaryUser">
        <div className={EMPTY}>
          <div>
            {submitError ? (
              <Alert
                key="messageAlert"
                variant={variant}
                closeAlert={(e) => closeAlert(e)}
                alertMessage={alertMessage}
                dismissible
              />
            ) : (
              EMPTY
            )}

            <Form id="formFieldDetails" noValidate validated={validated}>
              <Row>
                <Form.Group controlId="season" as={Col} md="5" className="me-6">
                  <Form.Label>Season</Form.Label>
                  <Form.Select
                    size="sm"
                    name="season"
                    value={year}
                    required
                    onChange={handleChangeYear}
                  >
                    {years}
                  </Form.Select>
                </Form.Group>
                <Form.Group controlId="total-acres" as={Col} md="3">
                  <Form.Label>Total Acres</Form.Label>
                  <Form.Control
                    type="text"
                    size="sm"
                    disabled={true}
                    value={yearAcre}
                  />
                </Form.Group>
                <Form.Group controlId="remaining-acres" as={Col} md="3">
                  <Form.Label>Available Acres</Form.Label>
                  <Form.Control
                    type="text"
                    size="sm"
                    disabled={true}
                    value={availableAcres}
                  />
                </Form.Group>
              </Row>
              <div className="crop-row-height">{cropDetails}</div>
              {hasAccessValue && (
                <Row className="mt-2">
                  <Form.Group controlId="crop" as={Col} md="5">
                    <Button
                      variant="button"
                      className="btn-add"
                      onClick={handleAddCrop}
                    >
                      <i className="fa fa-plus" /> Add Crop
                    </Button>
                  </Form.Group>
                </Row>
              )}

              {hasAccessValue && (
                <Row>
                  {props.sharedField ? (
                    <Form.Group as={Col} md="10">
                      <Button disabled={true}>Save</Button>{" "}
                      <Button disabled={true}>Save and close</Button>
                    </Form.Group>
                  ) : (
                    <Form.Group as={Col} md="10">
                      <Button
                        variant="primary"
                        onClick={(e) => saveCropDetails(e, false)}
                      >
                        Save
                      </Button>{" "}
                      <Button
                        variant="primary"
                        onClick={(e) => saveCropDetails(e, true)}
                      >
                        Save and close
                      </Button>
                    </Form.Group>
                  )}
                </Row>
              )}
            </Form>
          </div>
        </div>
        {removeCrop && (
          <PopUp
            showConfirmPopup={showConfirmPopup}
            message={confirmPopupMessage}
            closeWarningPopup={(e) => closeWarningPopup(e)}
            performWarningAction={(e, idx) => performWarningAction(e, idx)}
            header={header}
            index={index}
          />
        )}
      </div>
    </div>
  );
}

export default TabCropDetails;
